(function () {
  const SUBSCRIBE_COOKIE = 'olfa_newsletter_subscribed';
  const DISMISS_COOKIE = 'olfa_newsletter_dismissed';
  const PENDING_KEY = 'olfa_newsletter_pending';

  function hasCookie(name) {
    return document.cookie.split('; ').some((c) => c.startsWith(name + '='));
  }

  function setCookie(name, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=1; expires=${expires}; path=/; SameSite=Lax`;
  }

  function buildSuccessEl(title, desc) {
    const wrap = document.createElement('div');
    wrap.className = 'newsletter-popup__success';
    const h = document.createElement('h2');
    h.className = 'newsletter-popup__success-title';
    h.textContent = title;
    wrap.appendChild(h);
    if (desc) {
      const p = document.createElement('p');
      p.className = 'newsletter-popup__success-description';
      p.textContent = desc;
      wrap.appendChild(p);
    }
    return wrap;
  }

  function init() {
    // Shopify's challenge page renders the full theme — bail out so the popup
    // doesn't block the challenge UI. sessionStorage is preserved for the
    // return redirect that happens after the challenge completes.
    if (window.location.pathname === '/challenge') return;

    const popup = document.getElementById('newsletter-popup');
    if (!popup) return;

    const overlay = popup.querySelector('.newsletter-popup__overlay');

    function isOpen() {
      return popup.classList.contains('is-open');
    }

    function open() {
      popup.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
      const input = popup.querySelector('input[type="email"]');
      if (input) setTimeout(() => input.focus(), 350);
    }

    function close() {
      popup.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
    }

    function dismiss() {
      setCookie(DISMISS_COOKIE, 6 / 24); // 6 hours
      close();
    }

    // closeAction is dismiss by default; swapped to plain close on success so
    // we don't set a dismiss cookie when the user already subscribed.
    let closeAction = dismiss;

    // Attach close listeners unconditionally — they work in both form and
    // success states because they delegate through closeAction.
    popup.querySelector('.newsletter-popup__close')
      ?.addEventListener('click', () => closeAction());
    overlay?.addEventListener('click', (e) => {
      if (e.target === overlay) closeAction();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen()) closeAction();
    });

    function showSuccess() {
      closeAction = close; // success: just close, no dismiss cookie needed
      const content = popup.querySelector('.newsletter-popup__content');
      if (content) {
        content.innerHTML = '';
        content.appendChild(
          buildSuccessEl(
            popup.dataset.successTitle || 'Thanks for Subscribing!',
            popup.dataset.successDesc || ''
          )
        );
      }
      open();
    }

    // Detect return from challenge redirect: timestamp set just before submit.
    const pendingTs = parseInt(sessionStorage.getItem(PENDING_KEY) || '0', 10);
    if (pendingTs && Date.now() - pendingTs < 5 * 60 * 1000) {
      sessionStorage.removeItem(PENDING_KEY);
      setCookie(SUBSCRIBE_COOKIE, 365);
      showSuccess();
      return;
    }
    sessionStorage.removeItem(PENDING_KEY);

    // Liquid-rendered success state (direct submission without challenge).
    const successEl = popup.querySelector('[data-success="true"]');
    if (successEl) {
      setCookie(SUBSCRIBE_COOKIE, 365);
      showSuccess();
      return;
    }

    if (hasCookie(SUBSCRIBE_COOKIE) || hasCookie(DISMISS_COOKIE)) return;

    const form = popup.querySelector('.newsletter-popup-form');
    if (form) {
      // Save timestamp before submit so we can detect the return page.
      form.addEventListener('submit', () => {
        sessionStorage.setItem(PENDING_KEY, Date.now().toString());
      });

      // Enter key in the email field should submit the form.
      form.querySelector('input[type="email"]')
        ?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            if (form.requestSubmit) {
              form.requestSubmit();
            } else {
              form.querySelector('[type="submit"]')?.click();
            }
          }
        });
    }

    const inDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;
    const delay = inDesignMode ? 0 : (parseInt(popup.dataset.delay, 10) || 3) * 1000;
    setTimeout(open, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
